const GET_DIVISIONAL_APPROVER_REQUISITION_TYPE = 'GET_DIVISIONAL_APPROVER_REQUISITION_TYPE';
const SET_DIVISIONAL_APPROVER_REQUISITION_TYPE = 'SET_DIVISIONAL_APPROVER_REQUISITION_TYPE';

export {
    GET_DIVISIONAL_APPROVER_REQUISITION_TYPE,
    SET_DIVISIONAL_APPROVER_REQUISITION_TYPE
};
